import React, { useState, useEffect, useCallback, useRef, useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import Search from '../../../components/Search';
import Loader from '../../../components/Loader';
import Modal from '../../../components/Modal';
import MissionDetails from '../../../components/MissionDetails';
import ResponsiveFooter from '../../../components/ResponsiveFooter';

import KidsIcon from '../../../assets/icons/girl_s.png';
import MissionsIcon from '../../../assets/icons/missions_green.png';

import { SearchContext } from "../../../hooks/SearchContext";
import formatMission from "../../../utils/formatMission";

import api from '../../../services/api';

import { Container, Content } from './styles';
import BindMission from '../../../components/BindMission';
import { set } from 'date-fns';

const Missions = () => {
  const history = useHistory();
  const { filteredList, notFound } = useContext(SearchContext);
  const [loading, setLoading] = useState(false);
  const [missions, setMissions] = useState([]);
  const [toggleModal, setToggleModal] = useState(false);
  const [selectedMission, setSelectedMission] = useState({});
  const [toggleModal2, setToggleModal2] = useState(false);

  //!infite scroll
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const token = localStorage.getItem("@Ocariot:token");

  const observer = useRef(null);

  const lastMissionElementRef = useCallback(
    (item) => {
      if (loading) return;

      if (total > 0 && missions.length === total) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) setPage(page + 1);
      });

      if (item) observer.current.observe(item);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loading, hasMore]
  );

  const loadMissions = () => {
    setLoading(true);
    api.get('mission', {
      params: {
        populate: "goals",
        sort: { field: "nickname", order: 1 },
        pagination: { page, perPage: 11 },
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((res) => {
      setTotal(res.data.total);
      setHasMore(res.data.data.length > 0);
      setMissions(childrenState => [...childrenState, ...res.data.data]);
      setLoading(false);

    }).catch((err) => {
      toast.error("Erro ao carregar crianças");
      setLoading(false);
      console.log(err);
    });
  }

  useEffect(() => {
    loadMissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page])
  return (
    <>
      <Modal
        width={700}
        height={1000}
        show={toggleModal}
        onClose={() => setToggleModal(false)}
        title="Atrelar criança"
        haveButton={true}
        buttonLeft="Adicionar"
      >
        <BindMission missions={missions} setModalState={setToggleModal} />
      </Modal>
      <Modal
        width={1000}
        height={1000}
        show={toggleModal2}
        onClose={() => setToggleModal2(false)}
        title="Detalhes da missão"
        haveButton={false}
      >
        <MissionDetails mission={selectedMission} setModalState={setToggleModal2} />
      </Modal>
      <Container>
        <Content>

          <header>
            <Link to="/dashboard">
              <div className="flex-div">
                <img src={KidsIcon} alt="Crianças" />
                <h2>Crianças</h2>
              </div>
            </Link>
            <Link to="/missions">
              <div className="flex-div">
                <img src={MissionsIcon} alt="Missões" />
                <h2>Missões</h2>
              </div>
            </Link>
          </header>
          <div className="body">
            <div className="first-line-body">
              <div>

                <button className="default-bnt" onClick={() => history.push('missions/add-missions')}>
                  Adicionar Missão
                </button>
                <button className="default-bnt" onClick={() => setToggleModal(true)}>
                  Atrelar missão à criança
                </button>
              </div>
              <Search placeholder="Buscar missão..." component="mission" qField="title" />
            </div>
            <br />
            <p>Total de missões cadastradas: <strong>{total}</strong></p>
            {(loading && missions.length === 0) ? (
              <div className="loader-div">
                <Loader color="blue" />
              </div>


            ) : (
              <div className="scroll-body">
                {(filteredList.length === 0 && !notFound) ? (
                  <table id="childrens-table">
                    <thead>
                      <tr>
                        <th>Título</th>
                        <th>Habilidade</th>
                        <th>Objetivos</th>
                        <th></th>
                        <th>Pontuação</th>
                        <th>Duração</th>
                      </tr>
                    </thead>
                    <tbody >
                      {missions.map((mission, idx) => (
                        <tr ref={missions.length === idx + 1 ? lastMissionElementRef : null} key={mission._id} onClick={() => {
                          setSelectedMission(mission)
                          setToggleModal2(true)
                          }}>
                          <td>{mission.title}</td>
                          <td>{mission.skill}</td>
                          <td
                            style={{
                              maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
                            }}>
                            {formatMission(mission.goals)}
                          </td>
                          <td style={{ width: '100px' }}></td>
                          <td style={{ textTransform: "lowercase" }}>{mission.score} pontos</td>
                          <td style={{ textTransform: "lowercase" }}>{mission.duration} dias</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : !notFound ? (
                  <table id="childrens-table">
                    <thead>
                      <tr>
                        <th>Título</th>
                        <th>Habilidade</th>
                        <th>Objetivos</th>
                        <th></th>
                        <th>Pontuação</th>
                        <th>Duração</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredList.map((mission, idx) => (
                        <tr ref={missions.length === idx + 1 ? lastMissionElementRef : null} key={mission._id} onClick={() => {
                          setSelectedMission(mission)
                          setToggleModal2(true)
                          }}>
                          <td>{mission.title}</td>
                          <td>{mission.skill}</td>
                          <td style={{
                            maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
                          }}>
                            {formatMission(mission.goals)}
                          </td>
                          <td style={{ width: '100px' }}></td>
                          <td>{mission.score}</td>
                          <td style={{ textTransform: "lowercase" }}>{mission.duration}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (<p>Não foram encontradas missões</p>)}
                {loading && (<><br /><Loader color="blue" /></>)}
                {(!loading && (missions.length === 0)) && (<p>Ainda não foram cadastradas crianças</p>)}
              </div>
            )}
          </div>
          {!loading && <ResponsiveFooter />}
        </Content>
      </Container>
    </>
  );
}
export default Missions;